import React, { useEffect, useState } from "react";
import { browserMediaUrl } from "@/lib/media";

const DEFAULT_AVATAR = "/icons/avatar-default-512.png";

export default function CoachAvatar({ src, name = "Coach DayOne", className = "h-12 w-12", imageClassName = "", priority = false }) {
  const [image, setImage] = useState(browserMediaUrl(src) || DEFAULT_AVATAR);

  useEffect(() => {
    setImage(browserMediaUrl(src) || DEFAULT_AVATAR);
  }, [src]);

  return (
    <span className={`block shrink-0 overflow-hidden rounded-full bg-slate-950 ring-1 ring-white/10 ${className}`}>
      <img
        src={image}
        alt={`Photo de ${name}`}
        loading={priority ? "eager" : "lazy"}
        className={`h-full w-full object-cover ${imageClassName}`}
        onError={() => setImage(DEFAULT_AVATAR)}
      />
    </span>
  );
}

export { DEFAULT_AVATAR };
